// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2GuPk","alertIcon":"ConfirmModal_alertIcon__2ChxA"};